import { useGetPortfolioHistoricalAnnualReturnsQuery } from "../../../services/valuations";

const usePortfolioHistoricalAnnualReturns = (masterAccountId) => {
    const { data, error, isError, isLoading, isFetching, isUninitialized, refetch } = useGetPortfolioHistoricalAnnualReturnsQuery({ masterAccountId }/*, { refetchOnMountOrArgChange: true }*/);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        reload : refetch
    };

};

export default usePortfolioHistoricalAnnualReturns;